import { AxiosInstance } from '../../utilities/requestClient';
import { SubFundSummaryData } from './types';

/** GET /sub_fund_setup/:fundId */
export const getSubFundSummary = async (
  fundId: string,
): Promise<SubFundSummaryData | null> => {
  const { data } = await AxiosInstance.get<SubFundSummaryData>(
    `sub_fund_setup/${fundId}`,
  );
  return data ?? null;
};
